import { ApiResponse } from '@interfaces/index';
import { apiUrlConfig } from './configs/apiUrlConfig';
import createApiClient from './configs/httpHandler';

export const insightsApiHandler = {
  getWellbeingInsights: async (): Promise<ApiResponse<InsightResponse>> =>
    createApiClient(apiUrlConfig.EXPRESS_BACKEND_V2).get(`/get-wellbeing-insights`),
};

export const fetchWellbeingInsights = async (): Promise<ApiResponse<InsightResponse>> =>
  insightsApiHandler.getWellbeingInsights();

export interface InsightTrigger {
  trigger: string;
  triggerType: string;
}

export interface InsightDetails {
  id: number;
  userId: number;
  wellbeingSnapshot: string | null;
  wellbeingStyle: string | null;
  patterns: string[] | null | [];
  trigger: InsightTrigger[];
  createdAt: string;
  updatedAt: string;
  recommendedActions: string[] | null;
}

export interface InsightResponse {
  insightDetails: InsightDetails | null;
  questionnairesCompleted: number;
}
